export const LOGIN_USER = "login_user";
export const SIGNUP_USER = "signup_user";
export const WORD_DATA = "word_data";
